import { render, staticRenderFns } from "./caseS.vue?vue&type=template&id=15c6bd23&scoped=true"
import script from "./caseS.vue?vue&type=script&lang=js"
export * from "./caseS.vue?vue&type=script&lang=js"
import style0 from "./caseS.vue?vue&type=style&index=0&id=15c6bd23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6bd23",
  null
  
)

export default component.exports